module.exports = __webpack_public_path__ + "cd455783/img/lock-icon.bb9c7166.svg";